.formFieldsContainer, .fieldGroupContainer, .fieldContainer, .buttonContainer, .overflowContainer, .accordionContainer, .accordionHeaderContainer {
    display: flex;
}

.fieldContainer, .dragAndDrop {
    margin-bottom: 20px;
}

.formFieldsContainer {
    flex-direction: column;
    margin-bottom: 0px;
}

.fieldGroupContainer {
    gap: 10px;
}

.fieldContainer {
    flex: 1 1;
}

.fieldContainer > * {
    width: 100%;
}

.overflowContainer {    
    padding-right: 16px;
}

.buttonContainer {
    flex-direction: row;
    justify-content: space-between;
    margin: 10px 0;
}

.submitButton {
    margin-left: auto;
}

.accordionContainer {
    display: flex;
    align-items: flex-start;
}

.accordionContainer > button {
    display: flex;
    justify-content: flex-start;
}

.accordionHeaderContainer {
    width: 100%;
    flex-direction: column;
}

.accordionCollapse {
    margin: 12px;
}

.riskMapping {
    margin-top: 20px;
    margin-bottom: 20px;
}